module.exports = __webpack_public_path__ + "img/Thumbnail-Vegetables.e1140a36.jpg";